import ReactModal from "../../Common/ReactModal";
import React from "react";
class AtriaUserView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: "You dont have permission to do this Action",
      Roles_Feature_ID: 175
    };
    this.editRoles = this.editRoles.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }
  submitModal() {
    this.setState({ reactModalVisible: false });
  }
  editRoles() {
    if (this.props.accessSpecifier[this.state.Roles_Feature_ID].editP) {
      this.props.toggleEditMode(true);
    } else {
      this.setState({ reactModalVisible: true });
    }
  }
  render() {
    // console.log("props data",this.props);
    const {
      id,
      roleName,
      description,
      statusDetail,
      entityType
    } = this.props.user;
    const { reactModalVisible, requireCancel, modalMessage } = this.state;
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={requireCancel}
        />
        <div className="row">
          <div className="col-md-11">
            <h1 className="heading m-b-25">Role Details</h1>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            {/* Form Section start */}
            <div className="box-card">
              <div className="row">
                <div className="col-md-6" />
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>ROLE NAME</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      defaultValue={roleName}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>DESCRIPTION</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      defaultValue={description}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>STATUS</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      defaultValue={
                        statusDetail && statusDetail.length
                          ? statusDetail[0].name
                          : ""
                      }
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>ENTITY TYPE</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      defaultValue={
                        entityType == 1
                          ? " Investor "
                          : entityType == 2
                          ? " User"
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={this.editRoles}
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
            {/* Form Section End */}
          </div>
        </div>
      </>
    );
  }
}

export default AtriaUserView;
